<div class="control-line mat-elevation-z8">
    <!-- Market (mat-select with in-panel search) -->
    <div class="filter-actions-line">
        <mat-form-field appearance="outline" class="date-field">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="MM/DD/YYYY" [(ngModel)]="selectedDate"
                (keydown)="onKeydown($event)" (blur)="dateformat($event)"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <button id="btnSearch" data-testid="btnSearch" mat-raised-button color="primary" (click)="onSearch()">
            <mat-icon>search</mat-icon>Search
        </button>
        @if(controlPermissions.addButton){
            <button data-testid="btnSave" [disabled]="!hasAnyChange" mat-raised-button color="primary" mat-primary
                (click)="onUpdate()">
                Save
            </button>
        }
    </div>
</div>
<div class="gridheight mat-elevation-z8 viewport mar-top-20" style="width: 30%;">
    <table mat-table [dataSource]="dataSource" class="excel-table" matSort>
        <ng-container matColumnDef="hour">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hour</th>
            <td mat-cell *matCellDef="let row; let i = index" (click)="selectRow(i)">
                <input matInput type="number" [formControl]="row.get('hour')"  />
            </td>
        </ng-container>
        <ng-container matColumnDef="mcF_Volume">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>MCF Volume</th>
            <td mat-cell *matCellDef="let row; let i = index" (click)="selectRow(i)">
                <input matInput type="text" maxlength="2" [formControl]="row.get('mcF_Volume')" 
                    (keypress)="numbersOnly($event)" />
            </td>
        </ng-container>
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td *matCellDef="let row; let i = index" (click)="selectRow(i)">
                <input type="hidden" [formControl]="row.get('id')" />
            </td>
        </ng-container>

        <ng-container matColumnDef="rngDate">
            <th mat-header-cell *matHeaderCellDef>rngDate</th>
            <td *matCellDef="let row; let i = index" (click)="selectRow(i)">
                <input type="hidden" matInput placeholder="MM/DD/YYYY" [matDatepicker]="picker"
                    [formControl]="row.get('rngDate')" />
                <mat-datepicker #picker></mat-datepicker>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!--  trackBy added here -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>

    </table>
</div>